import { ImageUpload } from "@/components/ImageUpload";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export function MultiImageUpload({ label, images = [], onChange, testid, aspect = "aspect-square", hint = "Add photo" }) {
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= images.length) return;
    const a = [...images];
    [a[i], a[j]] = [a[j], a[i]];
    onChange(a);
  };
  const remove = (i) => onChange(images.filter((_, idx) => idx !== i));

  return (
    <div data-testid={testid}>
      {label && <label className="block text-sm font-semibold text-slate-700 mb-1.5">{label}</label>}
      <div className="grid grid-cols-3 gap-2">
        {images.map((img, i) => (
          <div key={i} className={`relative ${aspect} rounded-lg overflow-hidden border border-slate-200 group`} data-testid={`${testid}-item-${i}`}>
            <img src={img} alt="" className="w-full h-full object-cover" />
            {i === 0 && <span className="absolute top-1 left-1 bg-[#0a1420] text-white text-[9px] font-bold px-1.5 py-0.5 rounded">MAIN</span>}
            <button type="button" onClick={() => remove(i)} data-testid={`${testid}-remove-${i}`} className="absolute top-1 right-1 bg-white/90 rounded-full p-1 hover:bg-white shadow"><X size={12} /></button>
            <div className="absolute bottom-1 left-1 right-1 flex justify-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
              <button type="button" onClick={() => move(i, -1)} disabled={i === 0} data-testid={`${testid}-left-${i}`} className="bg-white/95 rounded p-1 shadow disabled:opacity-30"><ChevronLeft size={12} /></button>
              <button type="button" onClick={() => move(i, 1)} disabled={i === images.length - 1} data-testid={`${testid}-right-${i}`} className="bg-white/95 rounded p-1 shadow disabled:opacity-30"><ChevronRight size={12} /></button>
            </div>
          </div>
        ))}
        <ImageUpload value="" onChange={(v) => v && onChange([...images, v])} hint={hint} aspect={aspect} testid={`${testid}-add`} />
      </div>
    </div>
  );
}
